export default __webpack_public_path__ + "static/media/imagem_01.5d94176e.jpeg";